export const VOICE_NOTE_LABELS = {
  voiceNoteAria: 'Record a voice note',
  voicePlayAria: 'Play voice note',
  voicePauseAria: 'Pause voice note',
  voiceSeekAria: 'Seek in voice note',
  voiceStopAria: 'Stop and send voice note',
  voiceCancelAria: 'Discard voice note',
  voiceTranscribing: 'Transcribing voice note…',
  voiceTooShort: 'That voice note was too short. Record a little longer and try again.',
  voiceMicDenied: 'Microphone access is required to send a voice note.',
  voiceUnsupported: 'Voice notes are not supported in this browser.',
  voiceError: 'Could not send that voice note. Please try again.',
  voiceTooLarge: 'That voice note is too large. Record a shorter note and try again.',
  voiceNoSpeech: 'No speech was detected in that voice note. Try again.',
} as const;

export const VOICE_WAVE_BARS = 28;
export const VOICE_MAX_SECONDS = 60;
export const VOICE_MIN_SECONDS = 1;
export const VOICE_MIN_BYTES = 800;
